import { useState } from 'react';
import { SidePanelExpandedContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const SidePanelContainer = (props: Props) => {

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <SidePanelExpandedContext.Provider value={[isExpanded, setIsExpanded]}>
      {props.children}
    </SidePanelExpandedContext.Provider>
  );
};
